module.exports = __webpack_public_path__ + "assets/img/study_3.c9665252.png";